import { createAsyncThunk } from '@reduxjs/toolkit';

import { ITopic } from '.';
import { APIDataProvider, TApiResponse, ApiPaths } from '../../api';
import { IGroupedTopic } from '../SubTopicSlice';

interface IGetTopics {
  curriculum: string;
  subject: string;
  subjectCode?: string;
  subjectLevel?: string;
}

const apiDataProvider = new APIDataProvider();

export const getTopics = createAsyncThunk(
  '/topics/list',
  async (data: { subjectCode: string; subjectLevel: string }) => {
    const response = await apiDataProvider.post<TApiResponse<ITopic[]>>(
      `${ApiPaths.topics}`,
      data
    );

    return response.data;
  }
);

export const getTopicsWithSubTopics = createAsyncThunk(
  '/topics/getTopics',
  async (data: IGetTopics) => {
    const response = await apiDataProvider.post<TApiResponse<IGroupedTopic[]>>(
      `${ApiPaths.topics}/getTopics`,
      data
    );

    return response.data;
  }
);

export const getTopicsBySubjectData = createAsyncThunk(
  '/topics/getTopicsBySubjectData',
  async (data: { curriculum: string; subject?: string }) => {
    let path = `${ApiPaths.topics}/getTopicsBySubjectData?curriculum=${data.curriculum}`;

    if (data.subject) {
      path += `&subject=${data.subject}`;
    }

    const response = await apiDataProvider.get<TApiResponse<ITopic[]>>(path);

    return response.data;
  }
);
